import { ProductsApiService } from '../service/website/productsApiService';

export const StorageConstant = {
  VERIFIED_PHONE: 'VERIFIED_PHONE',
  VERIFIED_EMAIL: 'VERIFIED_EMAIL',
  IS_LOGGED_IN: 'IS_LOGGED_IN',
  LOGIN_HEADER: 'LOGIN_HEADER',
  USER_TYPE: 'USER_TYPE',
  IS_AFFILIATE: 'IS_AFFILIATE',
  IS_SELLER: 'IS_SELLER',
};

export const PDP_VALUES = {
  WHOLESALE_INITIAL_MIN_QUANTITY: 2,
};

// Dynamic PRICE_LOGIC - all values loaded from active pricing algorithm in DB
export const PRICE_LOGIC = {};

let isInitialized = false;
let initPromise = null;

// Initialize pricing config from API
export const initPricingConfig = async () => {
  if (isInitialized) return PRICE_LOGIC;
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      const response = await ProductsApiService.getPricingAlgorithm();
      const data = response?.data?.data;

      if (data) {
        const formula = data.formula || {};
        console.log('[PricingConfig] API Response:', data);
        console.log('[PricingConfig] Formula:', formula);
        console.log('[PricingConfig] default_chargeable_weight:', formula.default_chargeable_weight);

        // All values from active DB pricing algorithm
        PRICE_LOGIC.CHINA_CONVERSION_RATE = formula.rmb_to_inr_rate ?? data.rmbRate;
        PRICE_LOGIC.DEFAULT_LOCAL_SHIPPING = (formula.local_shipping_rmb ?? 0) * (formula.rmb_to_inr_rate ?? data.rmbRate);
        PRICE_LOGIC.IMPORTERR_MARKUP_PERCENTAGE = formula.markup_percent ? formula.markup_percent * 100 : data.markupPercent;
        PRICE_LOGIC.HSNTaxPercent = formula.gst_default ? formula.gst_default * 100 : data.gstProductPercent;
        PRICE_LOGIC.DEFAULT_DW = formula.default_chargeable_weight;
        PRICE_LOGIC.WEIGHT_BUFFER_PERCENT = formula.weight_buffer_percent;
        console.log('[PricingConfig] WEIGHT_BUFFER_PERCENT set to:', PRICE_LOGIC.WEIGHT_BUFFER_PERCENT);
        PRICE_LOGIC.VOLUME_FACTOR = 5000;
        PRICE_LOGIC.MIN_ORDER_PLACE_AMOUNT = 300;
        PRICE_LOGIC.INITIAL_LMD_WEIGHT = 0.5;
        // PRICE_LOGIC.INITIAL_LMD_INR = formula.last_mile_base ?? data.lastMileDeliveryInr;
        PRICE_LOGIC.INITIAL_LMD_INR = 100;
        PRICE_LOGIC.EXTRA_500GM_LMD_INR = formula.last_mile_extra_per_500g;


        console.log('[PricingConfig] Final PRICE_LOGIC:', PRICE_LOGIC);
      }
      isInitialized = true;
    } catch (err) {
      console.error('[PricingConfig] Failed to fetch:', err);
    }
    return PRICE_LOGIC;
  })();

  return initPromise;
};

export const SellingModes = { Wholesale: 'wholesale', DropShipping: 'dropshipping' };
